/// <amd-module name="Wit/WorkItemForm/Common/Services/IWorkItemFormCommentService" />
import { CommentReactionType } from "Comments/Common/Contracts";
import { IReactionTypeToInfoMap } from "Comments/Reactions/Contracts";
import { IReadyableObservableArray } from "VSS/Core/Observable";
import { IVssService } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import * as WorkItemTracking from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { CommentFormat } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export interface IWorkItemFormCommentService extends IVssService {
    addComment(workItem: IWorkItem, comment: string): Promise<WorkItemTracking.Comment>;
    getObservable(workItem: IWorkItem): IReadyableObservableArray<ICommentWithReactions>;
    getComments(workItem: IWorkItem, top: number): Promise<unknown>;
    getTotalCommentsInWorkItem(workItem: IWorkItem): number | undefined;
    deleteComment(workItem: IWorkItem, commentId: number): Promise<void>;
    updateComment(workItem: IWorkItem, commentId: number, newValue: string, format?: CommentFormat): Promise<WorkItemTracking.Comment>;
    getRecentlyReactedUsers(workItem: IWorkItem, commentId: number, reactionType: WorkItemTracking.CommentReactionType, top: number): Promise<void>;
    createCommentReaction(workItem: IWorkItem, commentId: number, reactionType: CommentReactionType): Promise<void>;
    deleteCommentReaction(workItem: IWorkItem, commentId: number, reactionType: CommentReactionType): Promise<void>;
    syncCommentReactions(workItem: IWorkItem, commentId: number): Promise<void>;
}

export interface ICommentWithReactions {
    comment: WorkItemTracking.Comment;
    reactions: IReactionTypeToInfoMap;
    reactionPromises: { [reactionType: number]: Promise<IdentityRef[]> | undefined };
}
